import React from 'react'

const DragIcon = () => {
  return (
    <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_4099_82945"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={24}
    >
      <rect x={0.5} width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4099_82945)">
      <path
        d="M9.5 20C8.95 20 8.47933 19.8043 8.088 19.413C7.696 19.021 7.5 18.55 7.5 18C7.5 17.45 7.696 16.979 8.088 16.587C8.47933 16.1957 8.95 16 9.5 16C10.05 16 10.521 16.1957 10.913 16.587C11.3043 16.979 11.5 17.45 11.5 18C11.5 18.55 11.3043 19.021 10.913 19.413C10.521 19.8043 10.05 20 9.5 20ZM9.5 14C8.95 14 8.47933 13.804 8.088 13.412C7.696 13.0207 7.5 12.55 7.5 12C7.5 11.45 7.696 10.979 8.088 10.587C8.47933 10.1957 8.95 10 9.5 10C10.05 10 10.521 10.1957 10.913 10.587C11.3043 10.979 11.5 11.45 11.5 12C11.5 12.55 11.3043 13.0207 10.913 13.412C10.521 13.804 10.05 14 9.5 14ZM9.5 8C8.95 8 8.47933 7.804 8.088 7.412C7.696 7.02067 7.5 6.55 7.5 6C7.5 5.45 7.696 4.97933 8.088 4.588C8.47933 4.196 8.95 4 9.5 4C10.05 4 10.521 4.196 10.913 4.588C11.3043 4.97933 11.5 5.45 11.5 6C11.5 6.55 11.3043 7.02067 10.913 7.412C10.521 7.804 10.05 8 9.5 8ZM15.5 8C14.95 8 14.4793 7.804 14.088 7.412C13.696 7.02067 13.5 6.55 13.5 6C13.5 5.45 13.696 4.97933 14.088 4.588C14.4793 4.196 14.95 4 15.5 4C16.05 4 16.521 4.196 16.913 4.588C17.3043 4.97933 17.5 5.45 17.5 6C17.5 6.55 17.3043 7.02067 16.913 7.412C16.521 7.804 16.05 8 15.5 8ZM15.5 14C14.95 14 14.4793 13.804 14.088 13.412C13.696 13.0207 13.5 12.55 13.5 12C13.5 11.45 13.696 10.979 14.088 10.587C14.4793 10.1957 14.95 10 15.5 10C16.05 10 16.521 10.1957 16.913 10.587C17.3043 10.979 17.5 11.45 17.5 12C17.5 12.55 17.3043 13.0207 16.913 13.412C16.521 13.804 16.05 14 15.5 14ZM15.5 20C14.95 20 14.4793 19.8043 14.088 19.413C13.696 19.021 13.5 18.55 13.5 18C13.5 17.45 13.696 16.979 14.088 16.587C14.4793 16.1957 14.95 16 15.5 16C16.05 16 16.521 16.1957 16.913 16.587C17.3043 16.979 17.5 17.45 17.5 18C17.5 18.55 17.3043 19.021 16.913 19.413C16.521 19.8043 16.05 20 15.5 20Z"
        fill="#999FAC"
      />
    </g>
  </svg>
  )
}

export default DragIcon
